import { BrandMark } from './BrandMark'

const plans = [
  {
    name: 'ESSENTIAL WEBSITE',
    price: '$500',
    items: ['UP TO 5 PAGES', 'MOBILE RESPONSIVE', 'CONTACT FORM', 'BASIC SEO', '2 REVISION ROUNDS'],
  },
  {
    name: 'ADVANCED WEBSITE',
    price: 'FROM $750',
    items: ['UP TO 8 PAGES', 'PREMIUM MOTION', 'ADVANCED FORMS', 'BASIC INTEGRATIONS', '3 REVISION ROUNDS'],
  },
]

export function Pricing() {
  return (
    <section className="pricing-section" id="pricing">
      <p className="eyebrow">03 / PRICING</p>
      <div className="pricing-title-row">
        <h2>CLEAR SCOPE.<br /><em>CLEAN LAUNCH.</em></h2>
        <p>Focused packages for local businesses that need a sharper, more credible presence online.</p>
      </div>
      <div className="pricing-bands">
        {plans.map((plan, index) => (
          <article className="pricing-band" key={plan.name}>
            <span className="pricing-number">0{index + 1}</span>
            <div><h3>{plan.name}</h3><strong>{plan.price}</strong></div>
            <ul>{plan.items.map((item) => <li key={item}>{item}</li>)}</ul>
            <a href="#contact" aria-label={`Choose ${plan.name}`}>↗</a>
          </article>
        ))}
      </div>
      <p className="payment-line">50% TO BEGIN <i /> 50% AFTER FINAL APPROVAL</p>
      <div className="final-cta" id="contact">
        <div className="final-cta__copy">
          <BrandMark light={false} />
          <h2>YOUR NEXT WEBSITE<br />STARTS WITH <em>ONE FRAME.</em></h2>
          <a href="https://t.me/QoneCeo" target="_blank" rel="noreferrer">REQUEST A FREE HOMEPAGE CONCEPT <span aria-hidden="true">↗</span></a>
        </div>
        <a className="door-mark" href="https://t.me/QoneCeo" target="_blank" rel="noreferrer" aria-label="Message Q1 Websites on Telegram">
          <span>Q1</span><i>↗</i>
        </a>
        <div className="contact-line"><a href="https://t.me/QoneCeo" target="_blank" rel="noreferrer">@QoneCeo</a><a href="mailto:forworkwwwq@gmail.com">forworkwwwq@gmail.com</a></div>
      </div>
    </section>
  )
}
